// menu에 노출되는 메뉴 명칭
export default {
    notice: "공지",
    barogo_notice: "바로고 공지사항",
    member_company_inquiry: "회원사 업무문의",
    distributor_notice: "총판점 공지사항",
    store_work_process: "상점 업무처리",
    worker_notice: "라이더 공지사항",
    request_map: "세부지명 요청",
    report_download: "정산서 다운로드",
    baromoney_transfer_setting: "캐쉬 이동 설정",
    baromoney_account_receivable_list: "캐쉬이동 미수금 리스트",
    baromoney_accrued_expenses_list: "캐쉬이동 미지급 리스트",
    control: "관제",
    map_control: "지도관제",
    delivery_history: "배달내역",
    operation_setting: "운행설정",
    list_control: "목록관제",
    store: "상점",
    store_management: "관리",
    store_adjustment: "정산",
    store_stats: "통계",
    worker: "라이더",
    worker_management: "관리",
    worker_baromoney_history: "바로머니 내역",
    worker_profit: "수익",
    worker_monthly_attendance: "출근표",
    worker_adjustment: "정산",
    worker_statistics: "통계",
    hub: "허브",
    hub_management: "관리",
    hub_adjustment: "정산",
    hub_adjustment_test_mode_entrance: "정산 [테스트 모드]",
    hub_stats: "통계",
    policy: "정책관리",
    user_management: "사용자 관리",
    policy_delivery_amount: "@:common.delivery_charge",
    share_management: "공유관리",
    delivery_charge_area_control: "구역 설정",
    sales: "매출",
    baromoney_report: "바로머니 리포트",
    baromoney_report_basic: "기본",
    temporary: "임시",
    temporary2: "임시2",
    design_system_text: "[디자인 시스템] 텍스트",
    design_system_form: "[디자인 시스템] 폼",
    design_system_button: "[디자인 시스템] 버튼",
    post_update: "기존",
    post: {
        map_control: "지도관제",
        operation_setting: "운행설정",
        delivery_history: "배달내역",
        store_adjustment: "상점정산",
        baromoney_report: "바로머니 리포트",
        baromoney_report_basic: "기본",
        baromoney_report_period_comparsion: "기간별 비교",
        worker: "라이더",
        temporary: "임시",
        temporary2: "임시2",
    },
};
